// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RUVKk37YRJ {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.RUVKk37YRJ h4 {
  line-height: 3em;
}
.RUVKk37YRJ .jxRUJdd0eh {
  float: left;
  width: 100%;
}
.RUVKk37YRJ .Nq_JKmAzec {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.RUVKk37YRJ .Nq_JKmAzec:hover {
  cursor: pointer;
}
.RUVKk37YRJ .Nq_JKmAzec:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.RMfr3x8MPC .Ob0k5NSYXF:focus {
  outline: none;
}
.RMfr3x8MPC .Ob0k5NSYXF.cgq8AUQpoE.S2kE9GHuB7 {
  background: #375A88;
}
.RMfr3x8MPC .Ob0k5NSYXF.cgq8AUQpoE.S2kE9GHuB7 span {
  color: #fff;
}
.RMfr3x8MPC .S2kE9GHuB7 {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.RMfr3x8MPC .S2kE9GHuB7:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.RMfr3x8MPC input {
  height: 38px;
  min-width: 220px;
}
.Nq_JKmAzec.bOzpPBySTS {
  background: #410102;
}
.Nq_JKmAzec.z91aLTLENa {
  background: #911318;
}
.Nq_JKmAzec.MeEQlrpUkq {
  background: #D8293B;
}
.Nq_JKmAzec.t1YdSRm_Wg {
  background: #F2373C;
}
.Nq_JKmAzec.CIT8tV8OTP {
  background: #FC4448;
}
.Nq_JKmAzec.YAZ5Nk3fnL {
  background: #ED535E;
}
.Nq_JKmAzec.oFXccReql_ {
  background: #E34926;
}
.Nq_JKmAzec.L8pCB1jXvN {
  background: #FC562B;
}
.Nq_JKmAzec.y7IOyoew6t {
  background: #FC6722;
}
.Nq_JKmAzec.jUopb8XF9R {
  background: #FD7F24;
}
.Nq_JKmAzec.piWcSdVznB {
  background: #FD8D26;
}
.Nq_JKmAzec.OjNZ9ggr6O {
  background: #EC9C3E;
}
.Nq_JKmAzec.IHpfzx2Wtf {
  background: #0e673a;
}
.Nq_JKmAzec.yppqjKOHKY {
  background: #208740;
}
.Nq_JKmAzec.bO2hDOvsad {
  background: #239718;
}
.Nq_JKmAzec.pY_zhgA5p9 {
  background: #55A84D;
}
.Nq_JKmAzec.kniWzYg2Zo {
  background: #4BBE5A;
}
.Nq_JKmAzec.GBjUvaSsQA {
  background: #0CCA6A;
}
.Nq_JKmAzec.NF4zk6FyTs {
  background: #0A3C64;
}
.Nq_JKmAzec.yDPkikScII {
  background: #0d487a;
}
.Nq_JKmAzec.Pxpy1dgY8i {
  background: #10538d;
}
.Nq_JKmAzec.TCajfkTCeF {
  background: #115A99;
}
.Nq_JKmAzec.PH8S7T1meU {
  background: #3387E2;
}
.Nq_JKmAzec.J5DgwuxDoL {
  background: #1BA9CF;
}
.Nq_JKmAzec.suGEAJUTUr {
  background: #d27c02;
}
.Nq_JKmAzec.uQ6KErPVPA {
  background: #fb9402;
}
.Nq_JKmAzec.C7CdcDJEAW {
  background: #FD9B30;
}
.Nq_JKmAzec._pXeDMt3dD {
  background: #FDBE2D;
}
.Nq_JKmAzec.xdt451aYEb {
  background: #FED831;
}
.Nq_JKmAzec.OT0veqKd6_ {
  background: #FFFD38;
}
.Nq_JKmAzec.L6Ajr6wr2s {
  background: #2D215C;
}
.Nq_JKmAzec.MXAGqrhnWu {
  background: #483C83;
}
.Nq_JKmAzec.I4XeNxZFKV {
  background: #58518d;
}
.Nq_JKmAzec.gf85yL0z5L {
  background: #7068A9;
}
.Nq_JKmAzec.K51N7wI7mi {
  background: #7f78b2;
}
.Nq_JKmAzec.TOEnIpq9LP {
  background: #8f88bc;
}
.Nq_JKmAzec.cSrO8i0b9X {
  background: #000;
}
.Nq_JKmAzec.IayQqUDiSG {
  background: #282626;
}
.Nq_JKmAzec.yYcVslzfkU {
  background: #242222;
}
.Nq_JKmAzec.pbzGnWdtmU {
  background: #353838;
}
.Nq_JKmAzec.Pv3ojknED4 {
  background: #666;
}
.Nq_JKmAzec.vsKdxkwCIU {
  background: #999;
}
.ZLycdo2eeB {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.ZLycdo2eeB .IkzlwXALMg {
  display: none;
}
.WUgyWvDIuP {
  display: flex;
  align-items: center;
  width: 176px;
}
.WUgyWvDIuP .avviUSFZXv {
  font-size: 11px;
  z-index: 1000;
}
.WUgyWvDIuP .avviUSFZXv.wJq1EXPUIo {
  color: #EAAC6D;
}
.WUgyWvDIuP .avviUSFZXv.bwdDEiefYO {
  color: #53A92C;
}
.WUgyWvDIuP .PoozNUIyHi {
  border: none;
  padding: 0;
}
.WUgyWvDIuP .PoozNUIyHi:hover {
  cursor: default;
}
.WUgyWvDIuP .PoozNUIyHi .WNUn_dRukj.WNUn_dRukj {
  align-items: center;
  background-color: #fff;
  border: none;
  padding: 0;
  text-transform: uppercase;
  position: relative;
}
.WUgyWvDIuP .PoozNUIyHi .WNUn_dRukj.WNUn_dRukj::after {
  content: '';
  position: absolute;
  border-bottom: 2px dotted #000000;
  height: 75%;
  width: 100%;
}
.WUgyWvDIuP .PoozNUIyHi .WNUn_dRukj.WNUn_dRukj > div {
  color: #211E27;
  font-size: 11px;
  font-style: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 0;
  margin-right: 0;
}
.WUgyWvDIuP .PoozNUIyHi .WNUn_dRukj.WNUn_dRukj > div > div:last-child {
  max-width: 100% !important;
}
.WUgyWvDIuP .PoozNUIyHi .WNUn_dRukj.WNUn_dRukj > div > div:last-child > div {
  font-size: 11px;
}
.WUgyWvDIuP .PoozNUIyHi .WNUn_dRukj.WNUn_dRukj > div .m3wHuHZFlA {
  color: #211E27;
  font-size: 11px;
  font-style: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.WUgyWvDIuP .U6UAfDKHG_.wJq1EXPUIo {
  color: #999999;
}
.WUgyWvDIuP .q4SyWdSXj1 .WNUn_dRukj.WNUn_dRukj::after {
  border-color: #999999;
}
.WUgyWvDIuP .q4SyWdSXj1 .WNUn_dRukj.WNUn_dRukj > div .pulse-with-more__append-to span {
  color: #999999;
}
.McqqF7arFg.McqqF7arFg {
  background-color: #fff;
  border: none;
  box-shadow: none;
  width: 100%;
}
.McqqF7arFg.McqqF7arFg > div:last-child {
  margin-top: 0;
}
.RKOXcTUARz.RKOXcTUARz {
  padding: 0 !important;
}
.RKOXcTUARz.RKOXcTUARz > div:first-child {
  left: 40% !important;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `RUVKk37YRJ`,
	"color-row": `jxRUJdd0eh`,
	"color-tile": `Nq_JKmAzec`,
	"picker-component": `RMfr3x8MPC`,
	"picker-element": `Ob0k5NSYXF`,
	"active": `cgq8AUQpoE`,
	"btn": `S2kE9GHuB7`,
	"red-1": `bOzpPBySTS`,
	"red-2": `z91aLTLENa`,
	"red-3": `MeEQlrpUkq`,
	"red-4": `t1YdSRm_Wg`,
	"red-5": `CIT8tV8OTP`,
	"red-6": `YAZ5Nk3fnL`,
	"orange-1": `oFXccReql_`,
	"orange-2": `L8pCB1jXvN`,
	"orange-3": `y7IOyoew6t`,
	"orange-4": `jUopb8XF9R`,
	"orange-5": `piWcSdVznB`,
	"orange-6": `OjNZ9ggr6O`,
	"green-1": `IHpfzx2Wtf`,
	"green-2": `yppqjKOHKY`,
	"green-3": `bO2hDOvsad`,
	"green-4": `pY_zhgA5p9`,
	"green-5": `kniWzYg2Zo`,
	"green-6": `GBjUvaSsQA`,
	"blue-1": `NF4zk6FyTs`,
	"blue-2": `yDPkikScII`,
	"blue-3": `Pxpy1dgY8i`,
	"blue-4": `TCajfkTCeF`,
	"blue-5": `PH8S7T1meU`,
	"blue-6": `J5DgwuxDoL`,
	"yellow-1": `suGEAJUTUr`,
	"yellow-2": `uQ6KErPVPA`,
	"yellow-3": `C7CdcDJEAW`,
	"yellow-4": `_pXeDMt3dD`,
	"yellow-5": `xdt451aYEb`,
	"yellow-6": `OT0veqKd6_`,
	"purple-1": `L6Ajr6wr2s`,
	"purple-2": `MXAGqrhnWu`,
	"purple-3": `I4XeNxZFKV`,
	"purple-4": `gf85yL0z5L`,
	"purple-5": `K51N7wI7mi`,
	"purple-6": `TOEnIpq9LP`,
	"black-1": `cSrO8i0b9X`,
	"black-2": `IayQqUDiSG`,
	"black-3": `yYcVslzfkU`,
	"black-4": `pbzGnWdtmU`,
	"black-5": `Pv3ojknED4`,
	"black-6": `vsKdxkwCIU`,
	"picker-theme": `ZLycdo2eeB`,
	"arrow-regular": `IkzlwXALMg`,
	"customReviewRoot": `WUgyWvDIuP`,
	"customSelectIcon": `avviUSFZXv`,
	"fa-clock": `wJq1EXPUIo`,
	"fa-check-circle": `bwdDEiefYO`,
	"customSelectRoot": `PoozNUIyHi`,
	"customSelectContainer": `WNUn_dRukj`,
	"customPlaceholder": `m3wHuHZFlA`,
	"customSelectIcon--disable": `U6UAfDKHG_`,
	"customSelectRoot--disable": `q4SyWdSXj1`,
	"customSelect": `McqqF7arFg`,
	"customMenuCtn": `RKOXcTUARz`
};
export default ___CSS_LOADER_EXPORT___;
